var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-stacked-chart',{attrs:{"title":_vm.title,"values":_vm.getData,"series-name":_vm.seriesName,"category-name":_vm.categoryName,"loading":_vm.loading,"options":_vm.getBarChartOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }